export default "assets/images/logo-7e882732.png";